wbApp.controller('FormsResponseCtrl', ['$scope', '$modal', '$window', '$q', 'urlUtils', 'formSvc', 'formResponseSvc', 
    'securitySvc', 'userSvc', 'studentSvc',
function ($scope, $modal, $window, $q, urlUtils, formSvc, formResponseSvc, securitySvc, userSvc, studentSvc) {

    $scope.formId = urlUtils.getQueryParams().formId;
    $scope.formResponse = {};
    $scope.formDefinitionRevision = null;
    $scope.adminEdit = false;
    $scope.isSaving = false;
    $scope.respondedSuccesfully = false;

    $scope.isAuthenticated = securitySvc.isAuthenticated();
    
    $scope.shouldEnableSaveButton = function () {
        return !!$scope.formResponse.isValid && !$scope.isSaving;
    }

    function saveResponse(response) {

        let responseDto = angular.copy(response);
        responseDto.user = null;
        responseDto.student = null;
        responseDto.showFullEditableUserDetail = null;        
        
        formResponseSvc.insert(responseDto).$promise.then(function (success) {
                $scope.isSaving = false;
                $scope.respondedSuccesfully = true;
            },
            function (error) {
                $scope.isSaving = false;
                $scope.respondedSuccesfully = false;
                $scope.errorDetail = error;
            })
    }

    $scope.onSaveClick = function () {
        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;
        
        if (($scope.formResponse.showFullEditableUserDetail || $scope.formResponse.showFullEditableStudentDetail) &&
            !$scope.formResponse.isNotRegisteredUser &&
            $scope.isAuthenticated) {

            let promises = [];

            if (!!$scope.formResponse.user && $scope.formResponse.showFullEditableUserDetail) {
                promises.push(userSvc.update($scope.formResponse.user, null, null, true));
            }

            if (!!$scope.formResponse.student && $scope.formResponse.showFullEditableStudentDetail) {
                promises.push(studentSvc.update($scope.formResponse.student, null, null, null, true));
            }
            
            $q.all(promises).then(function() {
                saveResponse($scope.formResponse);
            }, function (error) {
                $scope.isSaving = false;
                $scope.respondedSuccesfully = false;
                $scope.errorDetail = error;
            });
        }
        else{
            saveResponse($scope.formResponse);
        }
    }
    
    $scope.onBackToFormListBtnClick = function () {
        $window.location.href = $window.location.origin + '/Forms'
    }

    $scope.onPrevBtnClick = function () {
        $window.location.href = $window.location.origin;
    }

    $scope.tabs = [
    {
        title: 'TXT_LBL_FORMS_RESPONSE',
        template: 'forms/forms-response-tab.html'
    }];

    $scope.tabs.activeTab = 0;

}]);